import React from 'react'
import LiquidacionFueraDeGradoView from '../../components/listados/LiquidacionFueraDeGradoView'

function LiquidacionFueraDeGrado () {
  return (
    <LiquidacionFueraDeGradoView />
  )
}

export default LiquidacionFueraDeGrado
